module.exports = {
  vantText: {
    confirm: '確認',
    cancel: '取消',
  },
  center: {
    title: '主頁',
    logout: '登出',
    coinDetail: '管理店鋪',
    coinDetail1: '我的賬單',
    coinTitle: '我的點數',
    recharge: '購買點數',
    cusservice: '我的客服',
    relativePhone: "更改電話號碼",
    myintroPeople: "我的介紹人",
    myClient: "我的客戶",
    platformList: '我的平台列表',
    platformInfo: '我的平台資料',
    chooseL: '語言選擇',
    chooseLang: "請選擇語言",
    message: '數據錯誤',
    tip: '注意: 只能有一個人登錄',
    back: '退出',
    isBack: '是否退出登錄',
  },
  ShopList: {
    title: '店鋪管理',
    message: '數據錯誤',
    addshop: '添加店鋪',
    add: '添加',
    enter: "進入",
    edit: '編輯',
    copy: "復制",
    delete: "刪除",
    setting: "店鋪設定",
    RechargeAmountSetting: "充值金額設定",
    addRechargeAmount: '添加充值金額',
  },
  member: {
    number: "序號",
    name: "名稱",
    nameplaceholder: "請輸入名稱",
    PaymentAmount: "支付金額",
    RechargeAmount: "充值金額",
    Discount: '折扣',
    PaymentAmountplaceholder: "請輸入支付金額",
    RechargeAmountplaceholder: "請輸入充值金額",
    Discountplaceholder: '請輸入折扣',
    Switch: "開關",
    order_number: "序號",
    order_numberPlaceholder: "請輸入序號",
    Operate: "操作",
    ConfirmWhetherToDelete: "確認是否刪除",
  },
  NewShop: {
    title: "設定店鋪",
    name: "名稱",
    address: "地址",
    pic: "圖片",
    phone: "電話",
    startTime: "開店時間",
    chooseStartTime: "選擇開店時間",
    endTime: "關門時間",
    chooseEndTime: "選擇關門時間",
    timeLimit: "服務時限",
    cookTime: "製作時間",
    intro: "介紹",
    chooseL: '店鋪語言',
    inputIntro: "輸入介紹",
    message: '數據錯誤',
    toast: '請填寫完整信息',
    minute: '分鐘',
    hour: '小時',
    shopType: '店鋪類型',
    chooseShopType: '請選擇店鋪類型'
  },
  DishDetail: {
    title: "詳情",
    specifications: '分量',
    tasteNotes: '口味/備註',
    message: '數據錯誤',
  },
  Dishes: {
    title: '請選擇',
    noneGoods: '暫無产品',
    message: '數據錯誤',
    pachage: '套餐',
  },
  PackageDetail: {
    title: '詳情',
    specifications: '分量',
    tasteNotes: '口味/備註',
    message: '數據錯誤',
    chooseSpecs: '選份量',
    note: '口味/備註',
    remark: '備註',
    inputRemark: "請輸入備註",
    certain: '確定',
    addToCart: '加入購物車',
  },
  EditBook: {
    title: '預訂',
    text: '門店未發佈',
    codeText: '預訂二維碼',
    copy: '複製鏈接',
    refresh: '刷新二維碼',
    copyBtn: '複製',
    refreshBtn: '刷新',
    message: '數據錯誤',
    bookSwitch: '預約顯示',
    takeawaySwitch: '外送顯示',
    menuSwitch: '菜單顯示',
    pickSwitch: '打包顯示',
  },
  EditDish: {
    title: "產品設置",
    category: '分類',
    noChoose: "不選擇，則隱藏",
    cookName: '主名稱',
    enName: '副名稱',
    inputName: "輸入名稱",
    pic: "圖片",
    price: "價格",
    status: '單選',
    oldPrice: '原價',
    inputOldPrice: '輸入原價',
    newPrice: '特價',
    inputNewPrice: "輸入特價",
    commend: "推薦指數",
    prefer: "偏好設置",
    severce: "服務時長",
    intro: "介紹",
    inputIntro: "請輸入產品介紹",
    noChoose1: '若不選擇分類，則自動隱藏產品',
    message: '數據錯誤',
    toast: '請填寫完整信息',
    ingredients: '產品',
    checkbox: "多選開關",
    DisplaySwitch: "顯示開關",
    prompt: "不在同一分類內，排序無效"
  },
  EditPackage: {
    title: "套餐設置",
    packageName: "套餐名",
    enName: '副名稱',
    inputPackageName: "輸入套餐名",
    pic: '圖片',
    price: "價錢",
    OldPrice: "填寫原價",
    inputOldPrice: "輸入原價",
    newPrice: "填寫特價",
    inputNewPrice: "輸入特價",
    commend: "推薦指數",
    intro: "介紹",
    inputIntro: "請輸入套餐介紹",
    illustration: '說明',
    inputIllustration: '請輸入說明',
    addCook: "添加產品種類",
    text: "请先添加套餐包含的分類，然後在分類裡添加產品和設定差價",
    inputCategory: "請輸入分類",
    message: '數據錯誤',
    pleaseInputName: '请請填寫名稱。',
    toast: '請填寫完整信息',
    delCategory: '刪除分類',
    isDelCategory: '是否刪除已選擇的分類',
    chooseDelLabel: '請選擇要刪除的分類',
    chooseMoveLabel: '請選擇要移動的分類'
  },
  EditShop: {
    title: "設定店鋪",
    storeSetting: '店鋪功能設定',
    name: "名稱",
    inputName: "輸入名稱",
    address: "地址",
    inputAddress: "輸入地址",
    pic: "店鋪圖片",
    advertising_images: "廣告圖片",
    phone: "電話",
    inputPhone: "輸入聯絡電話",

    startTime: "開始營業時間",
    chooseStartTime: "選擇開始營業時間",
    endTime: "結束營業時間",
    chooseEndTime: "選擇結束營業時間",

    startAfterTime: "午休開始時間",
    chooseStartAfterTime: "選擇午休開始時間",
    endAfterTime: "午休結束時間",
    chooseEndAfterTime: "選擇午休結束時間",

    cookTime: "服務限時",
    cookingTime: "製作時間",
    intro: "店鋪介紹",
    inputIntro: "輸入介紹",
    message: '數據錯誤',
    toast: '請填寫完整信息',
    minute: '分鐘',
    chooseL: '店鋪語言',
    currency: '店鋪貨幣',
    chooseCurrency: '請選擇貨幣',
    color: "店鋪顏色選擇",
    inputColor: "請選擇顏色",

    fail_time: "外送超時時長",
    inputFail_time: "輸入外送超時時長",
    isQuick: '快捷點單',
    isServiceCharge: '座位點餐-啓服務費',
    serviceCharge: '服務費',
    isDiscountFee: '座位點餐-折扣費',
    isFloat: '保留金额精度',
    isAdditional: '外送-地區附加費',
    amountExempt: '達到免除地區附加費的金額',
    amount: '請輸入金額',
  },
  EditTable: {
    title: "區域人數設置",
    peopleNum: '人以上',
    num: '人',
    certain: '修改設置',
    certainBtn: '修改',
    copy: '點擊複製鏈接',
    screenQRcode: '屏幕二維碼',
    refresh: '點擊刷新二維碼',
    lineQRcode: '排隊二維碼',
    message: '數據錯誤',
    copyScuess: '複製成功',
    screenLink: "屏幕鏈接:"
  },
  MenuRank: {
    title: "產品排行",
    text1: '從',
    text: '至',
    price: "金額",
    rank: '排名',
    cookName: '名稱',
    price1: '價格',
    num: '數量',
    money: "金額",
    portion: '份',
    portionNum: "份數",
  },
  NewDish: {
    title: "設定產品",
    cookName: '名稱',
    enName: '副名稱',
    inputName: "輸入名稱",
    pic: "圖片",
    price: "價錢",
    oldPrice: "原價",
    inputOldPrice: "輸入原价",
    newPrice: "特價",
    inputNewPrice: "輸入特價",
    commend: "推薦指數",
    setPrefer: "偏好設置",
    category: "分類",
    message: '數據錯誤',
    toast: '請填寫完整信息',
  },
  NewPackage: {
    title: "設定套餐",
    packageName: "套餐名",
    enName: '副名稱',
    inputPackageName: "輸入套餐名",
    pic: "圖片",
    price: "價錢",
    oldPrice: "原價￥",
    inputOldPrice: "輸入原价￥",
    newPrice: "特價￥",
    inputNewPrice: "輸入特價￥",
    commend: "推薦指數",
    message: '數據錯誤',
    toast: '請填寫完整信息',
  },
  NoData: {
    buy: '該功能需購買才能使用',
    noData: '暂无数据',
    sale: '請聯繫銷售人員'
  },
  PackageDish: {
    title: '設置內容',
    chooseCook: '選擇產品',
    compensationPrice: "補差價￥",
    inputMoney: "輸入金額",
    cancel: "取消",
    cook: "產品",
    save: '保存',
    message: '數據錯誤',
    inputCompensationPrice: '請輸入差價',
    pleaseChooseCook: '請選擇產品',
    del: '刪除',
    isDel: '是否刪除已選擇的產品',
    chooseDelCategory: '請選擇要刪除的分類',
  },
  ServiceBill: {
    title: "我的賬單",
    time: '時間',
    shopName: '點名',
    num: '已花點數',
    message: '數據錯誤',
    ActivateStore: '發佈',
    RechargePoints: '充值'
  },
  SetMenu: {
    title: "產品列表設置",
    category: "分類",
    inputCategory: "請輸入分類",
    prefer: "偏好",
    inputPrefer: "請輸入偏好",
    cook: "產品",
    inputCookName: "請輸入產品名",
    package: "套餐",
    inputPackageName: "請輸入套餐名",
    show: "排序",
    name: "名稱",
    showSwitch: "顯示",
    perferSwitch: "多選",
    price: "價格",
    edit: "操作",
    message: '數據錯誤',
    toast: '請填寫完整信息',
    del: '刪除分量',
    isDel: '是否刪除已選擇的偏好',
    chooseDelCategory: '請選擇要刪除的選項',
    delCategory: '刪除分類',
    isDelchooseCategory: '是否刪除已選擇的分類',
    delCook: '刪除產品',
    isDelCook: '是否刪除已選擇的產品',
    delPackage: '刪除套餐',
    isDelPackage: '是否刪除已選擇的套餐',
    batch: "批量綁定",
    Selected: "已選擇",
    term: "項",
    batchClass: "批量綁定分類",
    batchPerfer: "批量绑定偏好",
    batchPrice: "批量绑定價格",
    batchClassTitle: "請選擇批量綁定的分類",
    batchPerferTitle: "請選擇批量綁定的偏好",
    batchPriceTitle: "請輸入批量綁定的價格",
  },
  SetPerfer: {
    pleaseAdd: "請添加分量",
    message: '數據錯誤',
    toast: '請填寫完整信息',
    del: '刪除分量',
    isDel: '是否刪除已選擇的分量',
    chooseDelCategory: '請選擇要刪除的分類',
  },
  ShopStatus: {
    title: "店鋪狀態",
    publishsShop: '發佈店鋪',
    servicePoint: '點數餘額',
    count: '點',
    cancel: '取消',
    certain: '確定',
    note: "注意事項",
    p1: '已購買的使用天數僅限於當前店鋪使用',
    p2: '天數一經購買無法撤回，因此購買後不接受退款，敬請理解。',
    p3: '刪除當前店鋪後，店鋪剩餘天數恕不退還，請謹慎操作。',
    p4: '最終解釋權歸本公司所有。',
    shopType: '店鋪狀態',
    inActive: '未發佈',
    active: '已發佈',
    canUse: '可使用',
    day: '天',
    message: '數據錯誤',
    shopOnLine: '發佈店鋪',
    text: '發佈店鋪後將會扣除你',
    severceCount: '點數',
    InsufficientServicePoints: '您的點數不足'
  },
  ShopSet: {
    comment: "評論",
    deliveryTime: "交貨時間",
    deliveryDate: "交貨日期",
    PickUpDate: "取餐日期",
    PickUpTime: "取餐時間",
    title: "店功能",
    manage: "管理",
    set: "設定",
    report: "報表",
    statistical: "統計",
    editShop: "店鋪管理",
    setMenu: "產品管理",
    setSeat: "座位管理",
    staffList: "員工管理",
    shopStatus: "激活狀態",
    payEdit: "支付戶口設定",
    paySet: "支付類型",
    phoneList: '客戶資料', //'電話號碼列表',
    cookPrinting: "後廚打印功能",
    ticketPrinting: "小票打印功能",
    cookInfo: "後廚功能",
    editTable: "排隊功能",
    editBook: "店鋪主頁",
    monthReport: "月銷售報表",
    weekReport: "周銷售報表",
    dayReport: "日銷售報表",
    customerTime: "客量報告",
    menuRank: "產品排行",
    tableRank: "桌位排行",
    staffReport: "員工報表",
    cookTime: "製作時間",
    publishsShop: '發佈店鋪',
    servicePoint: '點數餘額',
    take_name: '收貨人姓名',
    take_tel: '電話號碼',
    take_address: '收貨地址',
    is_show: '是否展示',
    is_write: '是否必填',
    is_print: '是否打印',
    count: '點',
    cancel: '取消',
    certain: '確定',
    note: "注意事項",
    p1: '已購買的使用天數僅限於當前店鋪使用',
    p2: '天數一經購買無法撤回，因此購買後不接受退款，敬請理解。',
    p3: '刪除當前店鋪後，店鋪剩餘天數恕不退還，請謹慎操作。',
    p4: '最終解釋權歸本公司所有。',
    inActive: '未發佈',
    active: '已發佈',
    canUse: '可使用',
    day: '天',
    message: '數據錯誤',
    del: '刪除',
    isDelShop: '是否刪除當前店鋪？',
    shopOnLine: '發佈店鋪',
    text: '發佈店鋪後將會扣除你',
    severceCount: '點數',
    InsufficientServicePoints: '你的點數不足',
    autoPrint: '自動打印開關',
    printerSet: '打印機',
    stockList: '庫存報表',
    Ingredients: '關聯產品',
    IsItOpen: '店鋪營業',
    noIngredients: '暫無產品',
    isOut: '座位點餐-跳轉到外送界面',
    IsPay: '是否先支付',
    IsSkip: '座位點餐-選擇用餐人數',
    IsMerge: '按照訂單打印',
    clear: '座位點餐-付款后自動清潔座位表',
    member: "會員充值",
    auto: "外賣自動打印",
    seat: "小票二維碼",
  },
  SetSeat: {
    title: "設定座位",
    floor: '樓層',
    seat: '座位',
    downLoadQRcode: '全部下載',
    floorName: "樓層名稱",
    submit: '提交',
    tableName: '桌名',
    inputSeatNum: "輸入桌名",
    setNum: '設置人數',
    inputNum: "輸入人數",
    inputSeat: "輸入座位數",
    QRCode: '二維碼生成區',
    message: '數據錯誤',
    inputFloorName: '請輸入樓層名稱',
    delFloor: '刪除樓層',
    isDelFloor: '是否刪除已選擇的樓層',
    toast: '請填寫完整信息',
    delSeat: '刪除座位',
    isDelSeat: '是否刪除當前的座位',
    pleaseInputSeatNum: '請先填寫座位名',
    UsurpedRefreshQRcode: '若二維碼盜用，請重新刷新',
    refresh: '刷新',
    refreshTip: '確認刷新後原QRCode將永久失效',
    savePrint: '保存此二維碼，可以打印',
    download: '下載',
    copy: '複製鏈接'
  },
  CookInfo: {
    copy: '點擊複製鏈接',
    loginLink: "登錄鏈接:",
    refresh: '點擊刷新二維碼',
    message: '數據錯誤',
    copyScuess: '複製成功',
  },
  StaffList: {
    title: "員工設定",
    account: '賬號:',
    message: '數據錯誤',
  },
  NewStaff: {
    title: "新建員工",
    name: "姓名:",
    placeholderName: "姓名",
    gender: "性別:",
    placeholdergender: "性别",
    birth: "出生日期:",
    placeholderBirth: "出生日期",
    phone: "聯絡電話:",
    placeholderPhone: "聯絡電話",
    workTime: "入職時間:",
    placeholderWorkTime: "入職時間",
    post: "職位:",
    placeholderPost: "職位:",
    password: "密碼:",
    placeholderPassword: "密碼",
    man: '男',
    woman: '女',
    staff: '服務員',
    message: '數據錯誤',
    toast: '請填寫姓名',
  },
  EditStaff: {
    link: "登錄鏈接:",
    copy: '複製鏈接',
    refresh: '刷新二維碼',
    copyBtn: '複製',
    refreshBtn: '刷新',
    submit: '提交',
    delStaff: '刪除員工信息',
    isDelStaff: '是否刪除當前員工信息',
    success: '複製成功',
  },
  checkNum: {
    title: "驗證手機號",
    text: '為了保證你的賬號安全，需先驗證你的身份，驗證成功後可進行下一步操作',
    text2: '驗證碼將發送到',
    inputSMS: '輸入驗證碼',
    SMS: 'SMS驗證',
    retrieve: '秒後重新獲取',
    next: '下一步',
    message: '數據錯誤',
    pleaseInputSMS: '請填寫驗證碼'
  },
  UpdateNum: {
    title: "更換電話號碼",
    text: '為了保證你的賬號安全，新的手機號需驗證',
    input: "請輸入用戶名或手機號",
    inputSMS: "輸入驗證碼",
    SMS: 'SMS驗證',
    retrieve: '秒後重新獲取',
    certain: '確定',
    message: '數據錯誤',
    inputPhone: '請填寫手機號碼',
    fail: '驗證失效',
    toast: '請填寫完整信息',
  },
  ContactUs: {
    contact: '聯繫銷售人員',
    area: '地區',
    name: '姓名',
    phone: '電話',
    hongkong: '香港',
    taiwan: '台湾',
    zhuhai: '广东珠海',
    shanwei: '广东汕尾',
    shenzhen: '广东深圳',
    shantou: '广东汕头',
    dongguan: '广东东莞',
    guilin: '广西桂林',
    fuzhou: '福建福州',
    lin: '林先生',
    tian: '佃先生',
    chen: '陳先生',
    chan: '陳先生',
    qiu: '邱先生',
    liu: '刘先生',
    wang: '王先生',
    shi: '施先生',
    misschen: '陈小姐'
  },
  CookTime: {
    title: "製作時間",
    text1: '從',
    text: '至',
    longTime: '最長時間',
    name: '名稱',
    time: '時間',
    averageTime: '平均時間',
    shortTime: '最短時間',
  },
  CustomerTime: {
    title: "客量報告",
    text1: '從',
    text: '至',
    time: '時間',
    t: '時',
    peoopleNum: '人數',
    people: '人',
    num: '數量',
  },
  DayReport: {
    export: "導出",
    title: "日銷售報表",
    dateTime: "日期:",
    ticket: "流水號",
    num: "桌號",
    peoopleNum: '人數',
    price: '金額',
    people: '人',
    none: '今日沒有訂單',
  },
  StockReport: {
    title: "月庫存報表",
    yTitle: "年庫存報表",
    dTitle: '日庫存報表',
    y: '年',
    d: '日'
  },
  MonthDetail: {
    month: '月',
    date: '日期',
    peoopleNum: '人數',
    price: '金額',
    day: '日',
    people: '人',
  },
  MonthReport: {
    title: "月銷售報表",
    month: '月',
    m: '月',
    peoopleNum: '人數',
    price: '金額',
    money: '金額(/千)'
  },
  StaffReport: {
    title: "員工報表",
    text1: '從',
    text: '至',
    reserve: '預訂',
    rank: '排名',
    name: '姓名',
    num: '數量',
    one: '單',
    order: "下單",
    dishes: "上菜",
    clean: "清理桌面",
    settleAccounts: "結賬",
    type: '類型',
    out: '出庫',
    enter: '入庫'
  },
  TableRank: {
    title: "桌位排行",
    text1: '從',
    text: '至',
    amountOfMoney: "金額",
    peoopleNum: '人數',
    people: '人',
    rank: '排名',
    num: "桌號",
    price: '價格',
    amount: '數量',
  },
  WeekDetail: {
    text: '第',
    week: '周',
    date: '日期',
    amountOfMoney: "金額",
    peoopleNum: '人數',
    people: '人',
    weekReport: '周銷售報表',
    day: '天',
    money: '金額(/千)',
    prev: '上一周',
    next: '下一周',
  },
  WeekReport: {
    title: "周銷售報表",
    weeks: '周數',
    weekday: '日期',
    peoopleNum: '人數',
    amountOfMoney: "金額",
    money: '金額(/千)',
  },
  payMethod: {
    method: '支付方式',
    card: '信用卡',
    cash: '現金',
    other: '其他',
    totalprice: '總金額',
  },
  Login: {
    title: "靈活 · 輕便 · 省時的點菜系統",
    account: "請輸入賬號或手機號",
    password: "請輸入密碼",
    login: '登錄',
    forgetPassword: '忘記密碼?',
    register: '註冊',
    p1: "只需要一名員工一天的工資",
    p2: "只需要一頓飯的時間設定即可使用",
    p3: "提升餐館運作效率 增加營業額",
    p4: "第一步設定餐桌和菜品",
    p5: "第二步讓員工用手機打開網頁使用",
    p6: "第三步開始營業",
    p7: "陳老闆：用了這個系統，省了2个員工的工資，太正了！",
    p8: "服務員李小姐：客戶下單結賬更清晰，沒有給老闆罵了",
    p9: "王大廚：客戶越來越多，都忙不過來了",
    p10: "現在就聯絡我們的銷售人員，還可以享受額外的優惠哦！",
    contactUs: '聯繫我們',
    toast: '請輸入手機號和密碼',
    title1: '便捷點',
    title2: '掃碼點餐',
    title3: '自動出單',
    title4: '將餐飲管理化繁為簡',
    intro1: '註冊便捷點即可線上點餐，少了電話接單的手忙腳亂，訂單明細清晰明確。',
    intro2: '用便捷點掃碼即可掃碼點餐，減少服務人力，完成智慧便捷點餐。',
    intro3: '24小時雲端自動出單，不怕漏單，新訂單會直接打印。',
    intro4: '免APP！完整的O2O整合！單品銷售分析！實時查看店鋪狀態！整合多元行動支付，24小時接單不斷！透過豐富的方案組合及齊全的功能，便捷點功能無可比擬，讓您更輕鬆管理您的餐飲業務。',
  },
  ForgetPassword: {
    title: "忘記密碼",
    areaName: "區號選擇",
    inputPhone: "請輸入手機號",
    SMS: 'SMS認證',
    inputSMS: "輸入驗證碼",
    setNewPassword: "設置新密碼",
    certainPassword: "確認新密碼",
    submit: '提交',
    inputAreaNameAndPhone: '請輸入區號和手機號碼！',
    getSMSkey: '請先獲取驗證碼',
    toast: '請填寫完整信息',
    message: '數據錯誤',
    repasswordJudge: '密碼不一致'
  },
  Register: {
    title: "註冊",
    name: "用戶名",
  },
  phoneList: {
    title: '電話號碼列表',
    name: '姓名',
    phone: '電話號碼',
    noPhone: '沒有電話號碼'
  },
  CustomerList: {
    title: '客戶列表',
    noCustomer: '沒有客戶',
  },
  Pay: {
    type: '支付類型',
    selectType: '請選擇支付類型',
    id: '應用id',
    inputId: '請輸入您的應用id',
    secret: '密鑰',
    inputSecret: '請輸入您的密鑰',
    code: '商店代碼',
    inputCode: '請輸入您的商店代碼',
    file: '商戶私鑰文件',
    delete: '删除支付方式',
    isDelete: '是否刪除當前支付方式',
    create: '創建支付方式',
  },
  bindCode: {
    title: '綁定二維碼',
    link: '鏈接',
    inputLink: '請輸入鏈接',
    bind: '綁定'
  },
  printerSet: {
    name: '打印機',
    title: '打印機設置',
    order: '訂單打印機',
    queue: '排隊打印機',
    kitchen: '後廚打印機',
    printerBrand: '打印機品牌',
    printerSN: '打印機編號',
    printerKey: '打印機識別碼',
    testPrint: '測試打印',
    testTip: '請先添加打印機！',
    merge: '是否合併打印',
    del: '刪除',
    isDelPrint: '是否刪除該打印機',
    tagTitle: '樣式標籤',
    ptitle: '標題',
    remark: '備註',
    startlabel: '開始字符',
    endlabel: '結束字符',
  },
  print: {
    name: '打印樣式',
    kitchen: '後廚單',
    cash: '收銀單',
    order: '結賬單',
    handover: '交接班',
    addmenu: '加菜單',
    title: '標題',
    stand: '台位',
    number: '單號',
  },
  order: {
    title: '訂單詳情',
    ticket: '取餐碼',
  },
  platform: {
    platformSearch: '搜索平台',
    addPlatform: '创建平台资料',
    editPlatform: '编辑平台资料',
    deleteP: '删除平台资料',
    isDeleteP: '是否刪除當前平台资料',
    image: '店铺图片',
    code: '二维码',
    platCode: '平台二維碼',
    platLink: '平台鏈接',
    link: '链接',
    address: '地区附加费',
    createAdd: '创建地区附加费',
    itemInfo: '庫存管理',
    editAdd: '编辑地区附加费',
    delete: '删除地区附加费',
    isDelete: '是否刪除當前地区附加费',
    name: '名稱',
    platname: '平台名稱',
    platImage: '平台圖片',
    price: '價格',
    inputPlatName: '請輸入平台名稱',
    inputName: '请输入名稱',
    inputPrice: '请输入價格',
    inputLink: '请输入鏈接',
    platInputLink: '請輸入平台鏈接',
    successtips: '複製成功',
    errtips: '該瀏覽器不支持自動複製',
    warehousing: '入庫列表',
    issueList: '出庫列表',
    receiptSet: '收貨人訊息',
    shopList: '店鋪列表',
    ForceSurcharge: '強制地區附加費',
  },
  itemInfo: {
    name: '物品名稱',
    number: '物品數量',
    company: '物品單位',
    exWarehouse: '出庫',
    exWarehouseReason: '出庫原因',
    warehousing: '入庫',
    inputName: '請輸入物品名稱',
    inputNumber: '請輸入物品數量',
    successMsg: '添加成功',
    editSuccessMsg: '編輯成功',
    time: '時間',
    operation: '操作',
    deleteP: '删除物品信息',
    isDeleteP: '是否刪除當前物品信息',
    successDelMsg: '刪除成功',
    price: '物品價格',
    inputPrice: '請輸入物品價格',
    qualityDate: '保質期',
    date: '日期',
    exSuccess: '出庫成功',
    waSuccess: '入庫成功',
    overdue: '過期',
    consume: '消耗',
    unitTitle: '物品單位',
    addUnit: '新增單位',
    editUnit: '編輯單位',
    unitName: '單位名稱',
    unitsymbol: '單位符號',
    unitInputName: '請輸入單位名稱',
    unitInputsymbol: '請輸入單位符號',
    deleteUnitP: '刪除單位',
    isDeleteUnitP: '是否刪除當前單位信息',
    nodatamsg: '暫無數據，請去物品單位表添加',
    barCode: '條形碼',
    find: '查看',
    itemdetail: '詳情',
  },
  tax: {
    name: "稅費",
    add: "添加",
    delete: "删除",
    PleaseTaxName: "請輸入稅名",
    PleaseTaxPrice: "請輸入稅率",
  },
  invoice: {
    titile: "發票資料",
    pleaseInput: "請輸入",
    unifiedNumber: "統一編號",
    postMachineCode: "post機碼",
    postMachineSerialNumber: "post機序號",
    productName: "產品名稱",
    Authenticator: "認證碼",
    StoreCode: "門市編碼",
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/lang/hk.js